import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { getProfileVisual } from './profileVisuals';

export interface ProfileScoreCardProps {
  profileKey: string;
  score: number;
  // Conteudo do rodape do cartao: linha de aspeto (Lite) ou forecast (Pro).
  footer?: React.ReactNode;
  // Classes extra aplicadas ao cartao (ex.: sombra/hover usados pela Lite).
  className?: string;
}

// Cartao de score por perfil, orientado a dados via PROFILE_VISUALS, partilhado
// entre Insights Lite e Pro para deixarem de duplicar JSX (PL-005). O visual
// (icone e paleta) vem do perfil; o rodape e fornecido por quem consome.
const ProfileScoreCard: React.FC<ProfileScoreCardProps> = ({ profileKey, score, footer, className }) => {
  const { t } = useTranslation();
  const visual = getProfileVisual(profileKey);
  const Icon = visual.icon;

  return (
    <Card className={`${visual.cardClass}${className ? ` ${className}` : ''}`}>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center text-lg text-slate-800">
          <Icon className={`mr-2 h-5 w-5 ${visual.iconClass}`} />
          {t('profile_' + profileKey)}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="mb-2 text-2xl font-bold text-slate-800">{score}%</div>
        <Progress value={score} className="mb-2 h-2" indicatorClassName={visual.progressClass} />
        <p className={`text-xs ${visual.textClass}`}>{footer}</p>
      </CardContent>
    </Card>
  );
};

export default ProfileScoreCard;
